import React, { useState, useEffect } from 'react';
import './style.css';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import ContadorCardapio from '../../../Components/ContadorCardapio';
import Cookies from 'universal-cookie';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useCart } from '../../../CartContext';
import { useGlobal } from '../../../GlobalContext';
import Loading from '../../../Components/Loading';
import FloatingOrderButton from '../../../Components/FloatingOrderButton';
import ProgressiveImage from '../../../Components/ProgressiveImage';
import produtoSemImagem from '../../../Assets/produto-sem-imagem.png';
import gluten from '../../../Assets/icons/gluten.png';
import acucar from '../../../Assets/icons/acucar.png';
import laticinios from '../../../Assets/icons/laticinios.png';
import vegano from '../../../Assets/icons/vegano.png';
import vegetariano from '../../../Assets/icons/vegetariano.png';
import { formatDescription, truncateHtml } from '../../../Utills/formatText';
import { resolveClientColor } from '../../../Utills/colors';
import { t } from '../../../Utills/translations';

const { REACT_APP_URL_API } = process.env;

const restricoes = [
  { campo: 'gluten_free', nome: 'Sem glúten', icone: gluten },
  { campo: 'sugar_free', nome: 'Sem açúcar', icone: acucar },
  { campo: 'dairy_free', nome: 'Sem lactose', icone: laticinios },
  { campo: 'vegan', nome: 'Vegano', icone: vegano },
  { campo: 'vegetarian', nome: 'Vegetariano', icone: vegetariano },
];

const CardapioItem = () => {
  const { menu, loading, refreshCart } = useGlobal();
  const { cartItems } = useCart();
  const { cliente_id, item_id } = useParams();
  const location = useLocation();
  const cookies = new Cookies();

  const token = cookies.get('csrftoken2');
  const userIp = localStorage.getItem('ip_address');
  const session = localStorage.getItem('session');

  const [quantidade, setQuantidade] = useState(1);
  const [adicionaisSelecionados, setAdicionaisSelecionados] = useState({
    grupo1: [],
    grupo2: [],
  });
  const [isAdded, setIsAdded] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isFindingItem, setIsFindingItem] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  useEffect(() => {
    if (!loading && menu) {
      setIsFindingItem(false);
    }
  }, [loading, menu]);

  // 🔹 Listener para atualizar quando o carrinho mudar em outro lugar
  useEffect(() => {
    const handleCartUpdate = () => {
      if (typeof refreshCart === 'function') {
        refreshCart();
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);

    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [refreshCart]);

  const findItem = (menu) => {
    const itemId = parseInt(item_id, 10);
    for (const tipo of menu.tipo_refeicao) {
      for (const categoria of tipo.categoria_cardapio) {
        const item = categoria.item_cardapio.find((item) => item.id === itemId);
        if (item) return item;
      }

      if (tipo.item_cardapio_sem_cat) {
        const itemSemCat = tipo.item_cardapio_sem_cat.find(
          (item) => item.id === itemId,
        );
        if (itemSemCat) return itemSemCat;
      }
    }
    return null;
  };

  if (loading || !menu || isFindingItem) {
    return (
      <div className="loading-container">
        <Loading />
      </div>
    );
  }

  const item = findItem(menu);
  if (!item) return <div>Item não encontrado.</div>;

  const cor2 = resolveClientColor();
  const cor_letra = localStorage.getItem('cliente_cor_letra');
  const habilitaPedido =
    localStorage.getItem('cliente_pedido_menu') !== 'false';

  const handleQuantidadeChange = (novaQuantidade) => {
    setQuantidade(novaQuantidade);
  };

  const handleAdicionaisChange = (grupoId, itemId, itemNome, limit) => {
    setAdicionaisSelecionados((prev) => {
      const currentSelecionados = prev[grupoId] || [];
      const isSelected = currentSelecionados.some((item) => item.id === itemId);

      if (isSelected) {
        setErrorMessage('');
        return {
          ...prev,
          [grupoId]: currentSelecionados.filter((item) => item.id !== itemId),
        };
      } else {
        if (currentSelecionados.length >= limit) {
          setErrorMessage(
            `⚠️ Limite atingido: máximo de ${limit} item(s) para este grupo`,
          );
          setTimeout(() => setErrorMessage(''), 3000);
          return prev;
        }

        setErrorMessage('');
        return {
          ...prev,
          [grupoId]: [...currentSelecionados, { id: itemId, nome: itemNome }],
        };
      }
    });
  };

  const handleAddToCart = async () => {
    setIsAdding(true);

    const todosAdicionais = [
      ...adicionaisSelecionados.grupo1.map((item) => item.nome),
      ...adicionaisSelecionados.grupo2.map((item) => item.nome),
    ];

    const payload = {
      cliente_id,
      ip_address: userIp,
      session,
      language: navigator.language || navigator.userLanguage || 'pt-BR',
      operation: 'add',
      items: [
        {
          id: item.id,
          quantity: quantidade,
          additional_items: todosAdicionais,
        },
      ],
    };

    try {
      const response = await fetch(
        `${REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}&language=${navigator.language || navigator.userLanguage || 'pt-BR'}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': token,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok) {
        // 🔹 Atualiza o localStorage
        const storedCount = localStorage.getItem('cartItemsCount');
        const updatedCount = storedCount
          ? parseInt(storedCount, 10) + quantidade
          : quantidade;
        localStorage.setItem('cartItemsCount', updatedCount.toString());

        // 🔹 Atualiza o carrinho no contexto
        if (typeof refreshCart === 'function') {
          await refreshCart();
        }

        // 🔹 Dispara evento para outros componentes
        window.dispatchEvent(new Event('cartUpdated'));

        setIsAdded(true);
        setTimeout(() => {
          setIsAdded(false);
          setIsAdding(false);
        }, 1200);
      } else {
        throw new Error(data.message || 'Erro ao adicionar item');
      }
    } catch (err) {
      console.error('Erro ao adicionar item ao carrinho:', err);
      setErrorMessage(t('erroAdicionar'));
      setTimeout(() => setErrorMessage(''), 3000);
      setIsAdding(false);
    }
  };

  const renderGrupoItems = (grupo, grupoId, limit) => {
    if (!grupo || !grupo.items) return null;

    const selectedItems = adicionaisSelecionados[grupoId] || [];
    const currentCount = selectedItems.length;

    return (
      <div className="grupo-opcionais-card">
        {limit && limit < 999 && (
          <div className="limite-info">
            <span className="limite-selecao">
              📌 {currentCount}/{limit} itens selecionados
            </span>
          </div>
        )}
        {grupo.items.map((itemOption, index) => {
          const itemId = itemOption[0];
          const itemNome = itemOption[1];
          const isChecked = selectedItems.some(
            (selected) => selected.id === itemId,
          );
          const isDisabled = !isChecked && currentCount >= limit;

          return (
            <label
              key={index}
              className={`optional-card ${isDisabled ? 'disabled' : ''}`}
            >
              <input
                type="checkbox"
                onChange={() =>
                  handleAdicionaisChange(grupoId, itemId, itemNome, limit)
                }
                checked={isChecked}
                disabled={isDisabled}
              />
              <div className="optional-info">
                <span className="optional-name">{itemNome}</span>
              </div>
            </label>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <HeaderCardapio />
      <div className="MainGrid">
        <div className="container-cardapio-item fade-in">
          <div className="container-img-text">
            <div className="div__conteudo_cardapio">
              <ProgressiveImage
                src={item.img ? `${REACT_APP_URL_API}${item.img}` : produtoSemImagem}
                className="img-cardapio-animada"
                alt={item.nome}
              />
              <h3 className="titulo-item">{item.nome}</h3>
              <p
                className="descricao-item"
                dangerouslySetInnerHTML={{
                  __html: formatDescription(item.descricao),
                }}
              />
              {restricoes.some(({ campo }) => item[campo]) && (
                <div className="restricoes-item" aria-label="Restrições alimentares">
                  {restricoes.map(
                    ({ campo, nome, icone }) =>
                      item[campo] && (
                        <div className="restricao-item" key={campo}>
                          <img src={icone} alt={nome} />
                          <span>{nome}</span>
                        </div>
                      ),
                  )}
                </div>
              )}
              <p className="preco-item">
                R${' '}
                {item.valor.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
          </div>

          {habilitaPedido && item.habilita_pedido && (
            <div>
              {/* Primeiro grupo de opcionais */}
              {item.grupo_item_adicional && item.grupo_item_adicional.items && (
                <>
                  <hr />
                  <div className="div-text-opcionais">
                    <h1>{item.grupo_item_adicional.group_name}</h1>
                    <p>{item.grupo_item_adicional.group_description}</p>
                  </div>
                  <div className="div-opcionais-item">
                    {renderGrupoItems(
                      item.grupo_item_adicional,
                      'grupo1',
                      item.grupo_item_adicional.group_select_limit || 999,
                    )}
                  </div>
                </>
              )}

              {/* Segundo grupo de opcionais */}
              {item.grupo_item_adicional_2 &&
                item.grupo_item_adicional_2.items && (
                  <>
                    <hr />
                    <div className="div-text-opcionais">
                      <h1>{item.grupo_item_adicional_2.group_name}</h1>
                      <p>{item.grupo_item_adicional_2.group_description}</p>
                    </div>
                    <div className="div-opcionais-item">
                      {renderGrupoItems(
                        item.grupo_item_adicional_2,
                        'grupo2',
                        item.grupo_item_adicional_2.group_select_limit || 999,
                      )}
                    </div>
                  </>
                )}

              <div className="div-container-btn-cardapio">
                <div className="div-button-cardapio">
                  <ContadorCardapio
                    quantidade={quantidade}
                    onQuantidadeChange={handleQuantidadeChange}
                  />

                  <button
                    className={`btn-cardapio-add ${isAdded ? 'added' : ''} ${
                      isAdding ? 'adding' : ''
                    }`}
                    style={{
                      background: isAdded
                        ? '#3BBF9F'
                        : cor2 === 'outra'
                          ? cor2
                          : {
                              azul: '#4892DF',
                              verde: '#3BBF9F',
                              cinza: '#A6B1B4',
                              'cinza-solido': '#f2f2f2',
                              'azul-escuro': '#3d489b',
                              vermelho: '#FF5E5E',
                              laranja: '#FF9A38',
                              amarelo: '#FFFF00',
                              roxo: '#800080',
                              dourado: '#b99c56',
                              'azul-marinho': '#1C7FBC',
                              'azul-solido': '#315694',
                              marrom: '#673C0D',
                              branco: '#FFFFFF',
                            }[cor2] || cor2,
                      color: isAdded ? '#fff' : cor_letra,
                    }}
                    onClick={handleAddToCart}
                    disabled={isAdding}
                  >
                    {isAdded ? (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon-check"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                        {t('adicionado')}
                      </>
                    ) : isAdding ? (
                      <span className="loading-dots">{t('adicionando')}</span>
                    ) : (
                      `${t('adicionar')}: R$${(item.valor * quantidade).toLocaleString(
                        'pt-BR',
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        },
                      )}`
                    )}
                  </button>
                </div>

                {cartItems && cartItems.length > 0 && (
                  <div className="div-btn-carrinho">
                    <Link
                      to={`/${cliente_id}/carrinho${location.search}`}
                      className="btn-ver-carrinho"
                    >
                      🛒 {t('verCarrinho')} ({cartItems.length})
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mensagem de erro flutuante */}
      {errorMessage && <div className="error-toast">{errorMessage}</div>}

      <FloatingOrderButton themeColor={cor2} textColor={cor_letra} />
    </div>
  );
};

export default CardapioItem;
